import { jsx as _jsx } from "react/jsx-runtime";
var Bell = function Bell(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: /*#__PURE__*/_jsx("path", {
      d: "m5.514 16 1.18-1.182c.378-.378.586-.88.586-1.414V8.727c0-1.357.59-2.654 1.62-3.556a4.66 4.66 0 0 1 3.737-1.129c2.327.309 4.082 2.413 4.082 4.895v4.467c0 .534.208 1.036.585 1.413L18.485 16H5.515ZM14 18.341C14 19.24 13.083 20 12 20s-2-.76-2-1.659V18h4v.341Zm6.521-3.133-1.8-1.804V8.937c0-3.481-2.503-6.438-5.82-6.877a6.722 6.722 0 0 0-5.318 1.607 6.728 6.728 0 0 0-2.302 5.06v4.677l-1.802 1.804a1.631 1.631 0 0 0-.354 1.782c.255.614.848 1.01 1.512 1.01H8v.341C8 20.359 9.793 22 12 22s4-1.641 4-3.659V18h3.363c.664 0 1.256-.396 1.51-1.009a1.63 1.63 0 0 0-.352-1.783Z",
      fill: color
    })
  });
};
export default Bell;